var _title, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLongArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "longArrowLeft")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.1997805,10.5 L11,7.36289277 L12.3901207,6 L18,11.5 L12.3901207,17 L11,15.6371072 L14.1997805,12.5 L6,12.5 L6,10.5 L14.1997805,10.5 Z",
  id: "Combined-Shape",
  transform: "translate(12.000000, 11.500000) scale(-1, 1) translate(-12.000000, -11.500000) "
})));
export { SvgLongArrowLeft as ReactComponent };
export default __webpack_public_path__ + "static/media/longArrowLeft.7fe663ab.svg";